import React from "react";
import "../App.css";
import Logo from "../assets/Logo.png";
import AppStore from "../assets/appstore.svg";
import GPlay from "../assets/gplay.png";
import MainRight from "../assets/main2.png";

const Main = ({ t }) => {
  const copy = t.main;

  const scrollToJoinAlpha = () => {
    if (window.gtag) {
      window.gtag("event", "join_alpha_click", { target: "beta" });
    }

    requestAnimationFrame(() => {
      const el = document.getElementById("beta");
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  };

  let div = (
      <>
        <div className="i">
          <div className="i-left">
            <div className="logo-glitch" style={{ "--glitch-url": `url(${Logo})` }}>
              <img className="main" src={Logo} alt={copy.logoAlt} />
            </div>

            <h3>{copy.tagline}</h3>

            <button
                type="button"
                className="hero-cta hero-cta--alpha"
                data-label={copy.joinAlpha}
                onClick={scrollToJoinAlpha}
                aria-label={copy.joinAlphaAria}
            >
              <span>{copy.joinAlpha}</span>
            </button>

            <div className="stores">
              <a
                  className="store-btn"
                  style={{ "--btn-url": `url(${GPlay})` }}
                  href="https://play.google.com/store/apps/details?id=tr.production_hell.urban_samurai&utm_campaign=productionhell&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  aria-label={copy.gplayAria}
                  target="_blank"
                  rel="noopener noreferrer"
              >
                <div className="gplay-icon store-icon">
                  <img alt={copy.gplayAlt} src={GPlay} />
                </div>
              </a>

              <button
                  type="button"
                  className="store-btn store-btn--coming"
                  style={{ "--btn-url": `url(${AppStore})` }}
                  data-coming-soon={copy.comingSoon}
                  onClick={(e) => e.preventDefault()}
                  aria-label={copy.appStoreAria}
                  aria-disabled="true"
              >
                <div className="appstore-icon store-icon">
                  <img src={AppStore} alt={copy.appStoreAlt} />
                </div>
              </button>
            </div>

            <div className="contact-wrap">
              <div className="contact-box">
                <span className="contact-label">{copy.contact}</span>
                <a className="contact-link" href="mailto:productionhellstudio@gmail.com">
                  productionhellstudio@gmail.com
                </a>
              </div>
            </div>
          </div>

          <div className="i-right">
            <img className="main" src={MainRight} alt={copy.heroAlt} />
          </div>
        </div>
      </>
  );

  return div;
};

export default Main;
